import { DesignProp, GeneralProp } from "../PropCategories";

export const opacity = {
  prop: "style-attribute",
  name: "Opacity",
  nameI18n: "builder_ui.prop_type.styles.opacity",
  category: [DesignProp, GeneralProp],
  type: "number",
  defaultValue: 1,
  numberProps: {
    min: 0,
    max: 1,
    step: 0.1,
  },
} as const;
